import Units from "../../../utils/Units";
import Moisture from "../axes/Moisture";
import Day from "../axes/Day";

let MoistureDay = {
    type: "line",
    label: "Soil Moisture",
    fill: false,
    lineTension: 0,
    colorPalette: 9,
    borderWidth:2,

    pointStyle: "circle",
    pointRadius:0,
    pointHoverRadius: 2,
    pointBorderWidth:.5,
    z:50,

    tooltipLabelValueCallback: (value) => {
        return Units.rounded(value,2);
    },

    yAxis:Moisture,
    xAxis:Day
};

export default MoistureDay;



// WEBPACK FOOTER //
// ./src/components/chart/channels/MoistureDay.js